﻿﻿export interface IProductRequest {
    id: number;
    name: string;
    alias: string;
}
